export const config = {
	footer: {
		elevation: 3,
		color: '#fff'
	}
};
